'use strict';

/* heroblueprint.js -- entry for the home hero blueprint animation; loaded with `defer` by homeHero.cshtml */

var heroBlueprint = require('./components/heroBlueprint');

heroBlueprint.init();
